import React, { useContext } from 'react';
import { WMButton, WMButtonVariant, WMIconDownTriangle } from '@walkme/wm-ui';
import cc from 'classcat';
import { AppTableContext } from '../../../AppTableContext';
import classes from './SortButton.module.scss';

export const SortButton = ({ sorting, columnDataKey, isActiveSort }: $TSFixMe) => {
    const { tableDataTestid } = useContext(AppTableContext);
    const direction = ((isActiveSort && sorting.direction) || 'desc') === 'asc' ? 'asc' : 'desc';
    const activeDirection = isActiveSort && sorting.direction === direction;

    return (
        <WMButton
            className={cc([
                classes.sortControl,
                {
                    activeSort: isActiveSort,
                    [classes.active]: activeDirection,
                    [classes.ascending]: direction === 'asc'
                }
            ])}
            isIconButton
            iconComponent={<WMIconDownTriangle size={8} />}
            variant={WMButtonVariant.Text}
            data-testid={`${tableDataTestid}-${columnDataKey}-sort-trigger`}
        />
    );
};
